export default {
  bannerOESAhr: './img/summingup/summingup_oesa.jpg',
  bannerVGHhr: './img/summingup/summingup_vgh.jpg',
  bannerOEVBhr: './img/summingup/summingup_oevb.jpg',
  bannerOEVOhr: './img/summingup/summingup_oevo.jpg',
  bannerOESAglas: './img/summingup/summingup_oesa_glas.jpg',
  bannerVGHglas: './img/summingup/summingup_vgh_glas.jpg',
  bannerOEVBglas: './img/summingup/summingup_oevb_glas.jpg',
  bannerOEVOglas: './img/summingup/summingup_oevo_glas.jpg',
};
